import * as React from 'react'
import { useSearchParams } from 'react-router'

import { useCheckNonIdeaChartMissingConfig } from '../../../hooks/use-check-non-idea-chart-missing-config'
import { QuotePortalComponents } from '../PortalComponents'
import { QuoteContextProvider } from '../QuoteContext'
import { useStockDetailUpdater } from '../hooks/use-stock-detail-updater'
import { useToggleRatings } from '../hooks/useToggleRatings'
import { QuoteQuery } from '../types'

export default function QuoteSharedWrapper() {
  useCheckNonIdeaChartMissingConfig()
  useToggleRatings()

  const [query] = useSearchParams()
  const tickers = query
    .get(QuoteQuery.Ticker)!
    .toUpperCase()
    .split(',')
    .filter((ticker) => ticker.length > 0)
  const { isStockDetailUpdating } = useStockDetailUpdater()

  React.useEffect(() => {
    if (FinvizSettings.hasUserPremium || FinvizSettings.hasRedesignEnabled) {
      void import(/* webpackChunkName: "recent_quotes" */ '../../../../app/shared/recent_quotes')
        .then(({ updateRecentQuotesFromQuote }) => {
          updateRecentQuotesFromQuote()
        })
        .catch()
    }
  }, [])

  return tickers.map((ticker, index) => (
    <QuoteContextProvider key={ticker} ticker={ticker} index={index}>
      <QuotePortalComponents isStockDetailUpdating={isStockDetailUpdating} />
    </QuoteContextProvider>
  ))
}
